<template>
    <div>
        <div class="subscribe-loading">
            <div class="border"></div>
            <div class="image-container">
                <img src="/static/image/preparing-conf.svg">
            </div>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configurationButton/end-loading-btn.vue